module.exports = __webpack_public_path__ + "img/DTMEsports.7d423b53.svg";